module.exports = __webpack_public_path__ + "img/city.6cb89829.png";